module.exports = __webpack_public_path__ + "img/central-african-republic.589e660a.svg";